import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userId: null,
        baseUrl: null,
        accessToken: null,
        terminalUUID : null,
        user: null,
    },
    mutations: {
        setUserId(state, userId) {
            state.userId = userId;
        },
        setBaseUrl(state, baseUrl) {
            state.baseUrl = baseUrl;
        },
        setAccessToken(state, accessToken) {
            state.accessToken = accessToken;
        },
        setTerminalUUID(state, terminalUUID) {
            state.terminalUUID = terminalUUID;
        },
        setUser(state, user) {
            state.user = user;
        }

    },
    getters: {
        getUserId: state => {
            return state.userId;
        },
        getBaseUrl: state => {
            return state.baseUrl;
        },
        getAccessToken: state => {
            return state.accessToken
        },
        getTerminalUUID : state => {
            return state.terminalUUID
        },
        getUser : state => {
            return state.user
        }
    }
})

